import {
  H2,
  H3,
  H4,
  P,
  Ul,
  Li,
  StepList,
  FeatureCards,
  InfoBox,
  GlossaryTerm,
  Table,
  CodeBlock,
  Badge,
  StatusGrid,
  PromptCompare,
  ApiEndpointGroup,
  FaqList,
  DocImage,
  DocVideo,
} from "./BlockPrimitives";
import InlineContent from "./InlineContent";
import { resolveBlockIcon } from "./blockIcons";

const renderParagraph = (props) => (
  <P>
    <InlineContent content={props.content ?? props.text} />
  </P>
);

const renderList = (props) => (
  <Ul>
    {props.items.map((item, index) => (
      <Li key={index}>
        <InlineContent content={item.content ?? item} />
      </Li>
    ))}
  </Ul>
);

const renderInfoBox = (props) => (
  <InfoBox
    type={props.type}
    title={props.title}
    spaced={props.spaced}
    icon={props.iconKey ? resolveBlockIcon(props.iconKey) : undefined}
  >
    <InlineContent content={props.content ?? props.text} />
  </InfoBox>
);

const renderFeatureCards = (props) => (
  <FeatureCards
    items={props.items.map(({ iconKey, title, desc }) => ({
      icon: resolveBlockIcon(iconKey),
      title,
      desc,
    }))}
  />
);

const renderGlossaryTerm = (props) => (
  <GlossaryTerm
    icon={resolveBlockIcon(props.iconKey)}
    term={props.term}
    def={props.def}
  />
);

export const BLOCK_REGISTRY = {
  h2: (props) => <H2 id={props.id}>{props.text}</H2>,
  h3: (props) => <H3 id={props.id}>{props.text}</H3>,
  h4: (props) => <H4>{props.text}</H4>,
  p: renderParagraph,
  ul: renderList,
  stepList: (props) => <StepList steps={props.steps} />,
  featureCards: renderFeatureCards,
  infoBox: renderInfoBox,
  glossaryTerm: renderGlossaryTerm,
  table: (props) => <Table headers={props.headers} rows={props.rows} />,
  codeBlock: (props) => <CodeBlock code={props.code} language={props.language} />,
  badge: (props) => <Badge color={props.color}>{props.text}</Badge>,
  statusGrid: (props) => <StatusGrid items={props.items} />,
  promptCompare: (props) => (
    <PromptCompare bad={props.bad} good={props.good} badNote={props.badNote} />
  ),
  apiEndpointGroup: (props) => (
    <ApiEndpointGroup title={props.title} endpoints={props.endpoints} />
  ),
  faqList: (props) => <FaqList items={props.items} />,
  image: (props) => (
    <DocImage
      url={props.url}
      alt={props.alt}
      caption={props.caption}
      width={props.width}
      height={props.height}
    />
  ),
  video: (props) => (
    <DocVideo
      url={props.url}
      caption={props.caption}
      width={props.width}
      height={props.height}
    />
  ),
};

export function renderBlock(block, index) {
  const render = BLOCK_REGISTRY[block.type];

  if (!render) {
    if (process.env.NODE_ENV === "development") {
      console.warn(`[commonBlockRenderer] Unknown block type: ${block.type}`);
    }
    return null;
  }

  return (
    <div key={block.id ?? `${block.type}-${index}`}>
      {render(block.props ?? {})}
    </div>
  );
}
